import { LANG_LOCALE } from './context'
import type { Lang } from './context'

const BYTES_PER_MEGABYTE: number = 1024 * 1024

// A yyyy-MM-dd value is a calendar date, so format it in UTC to keep the day from shifting across time zones.
export function formatCalendarDate(isoDate: string, lang: Lang): string {
  return new Intl.DateTimeFormat(LANG_LOCALE[lang], { dateStyle: 'long', timeZone: 'UTC' }).format(new Date(isoDate))
}

/** File size the way Windows Explorer shows it: binary megabytes, one decimal. */
export function formatMegabytes(bytes: number, lang: Lang): string {
  return `${new Intl.NumberFormat(LANG_LOCALE[lang], { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(bytes / BYTES_PER_MEGABYTE)} MB`
}
